export default {
      id: "icon-exit-link-usage",
      viewBox: "0 0 18.458 14.545",
      url: __webpack_public_path__ + "img/icons.33fd9142.svg#icon-exit-link",
      toString: function () {
        return this.url;
      }
    }